'use strict';

(function () {
  'use strict';

  angular.module('msUtility').filter('localTime', LocalTimeFilter);
  LocalTimeFilter.$inject = ['$filter'];

  /**
   * Java's LocalTime is serialized as an array of [HH, MM, SS] or [HH, MM]
   * This takes that array and converts it to a fake date that can be used with the built in "date" filter
   * This is expected to be used as a replacement for the 'date' filter, when using LocalTime
   */
  function LocalTimeFilter($filter) {
    return function (time, format) {
      if (!time || time.length < 2 || time.length > 3) {
        return time;
      }

      var dt = new Date();
      dt.setHours(time[0]);
      dt.setMinutes(time[1]);
      if (time.length === 3) {
        dt.setSeconds(time[2]);
      } else {
        dt.setSeconds(0);
      }

      return $filter('date')(dt, format);
    };
  }
})();